<template>
  <div class="user-item">
    <el-card class="box-card">
      <div class="clearfix">
        <div class="user-item__name-wrap">
          <span>{{ user.displayName }}</span>
          <el-tag
            v-if="user.status === 'pendingDeletion'"
            size="mini"
            type="warning"
            style="margin-left: 20px;">
            Suppression demandée
          </el-tag>
        </div>
        <div class="user-item__subtext">{{ user.title }}</div>
        <el-button
          @click="$router.push({ name: 'UserProfile', query: { id: user.id } })"
          style="position: absolute; top: 10px; right: 20px;" type="text">
          {{ $t('usersListTable.openButtonText') }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import UserProfile from '@/entities/UserProfile';

export default {
  props: {
    user: { type: UserProfile },
  },
  methods: {},
};
</script>
<style lang="stylus" scoped>
.box-card {
  margin-bottom: 10px;
  position: relative;
}

.user-item__subtext {
  color: #757575;
}

.user-item__name-wrap {
  margin-bottom: 10px;
}
</style>
